import { useTranslation } from "react-i18next";
import type { Locale } from "@iso27001/shared";

/** The reader's current UI language, typed as `Locale` rather than i18next's bare `string`. */
export function useLocale(): Locale {
  const { i18n } = useTranslation();
  return i18n.language as Locale;
}
